import { Directive, HostListener, inject, Input } from '@angular/core';
import { HisSearchResultComponent } from '../../genericsearch/component/his-search-result.component';
import { HisDialogHeaderPaginatorService } from '../service/base/his-dialog-header-paginator.service';

@Directive( {
    selector: '[hisSearchResult]',
    standalone: false
} )
export class HisSearchResultHeaderContextProviderDirective {
    @Input( { alias: 'hisSearchResult', required: true } ) searchResultComponent: HisSearchResultComponent;
    @Input( 'selectedIndex' ) selectedIndex: number;

    private dialogHeaderPaginatorService = inject( HisDialogHeaderPaginatorService );

    constructor() { }

    @HostListener( 'click', ['$event'] )
    onClick( _: Event ) {
        if ( !this.searchResultComponent ) {
            return;
        }
        this.searchResultComponent.prepareNavigationContext().subscribe( ( dialogHeaderContext ) =>
            this.dialogHeaderPaginatorService.publishData( {
                ids: dialogHeaderContext.ids,
                changeSearchUrl: dialogHeaderContext.changeSearchUrl,
                newSearchUrl: dialogHeaderContext.newSearchUrl,
                index: this.selectedIndex ?? 0
            } )
        );
    }
}
